// libraries.
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// slices.
import {
  getCountry,
  getEmail,
} from '@domains/user/store/slices/user-slice/user-slice';
import { DocumentsTool } from '../../../../DocumentsVisualizer/interfaces/sideBar.types';
import { selectSidebarButton } from '@shared/Sidebar/store/slices/sidebar-slice';

// components.
import { ButtonSidebar } from '@shared';
import { getAgentsByEnv } from '@pages/DocumentAuditPage/modules/ReassignDocumentsTask/utils';

// assets.
import { IconReassign } from '@assets/icons';

export const ButtonReassignTasks = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const country = useSelector(getCountry);
  const email = useSelector(getEmail);

  const allowedAgents = getAgentsByEnv(country);

  if (!email || !allowedAgents.includes(email)) {
    return null;
  }

  const handleClick = () => {
    dispatch(selectSidebarButton(DocumentsTool.reassignTasks));
    navigate('/document-audit/reassign-tasks');
  };

  return (
    <ButtonSidebar
      icon={<IconReassign />}
      text="Asignaciones"
      onClick={handleClick}
    />
  );
};
